import React from 'react';
import '../styles/HorizontalTab.css';

function HorizontalTab(props) {
    const selected = props.selected;
    const label = props.label;
    const disabled = props.disabled;
    const cta = props.cta;
    const icon = props.icon;
    const iconLeft = props.iconLeft !== false; // Default to true

    return (
        <div className="horizontal-tab-outer-container">
            <div 
                className={"horizontal-tab-inner-container " + (selected === true ? "horizontal-tab-selected-container " : "horizontal-tab-unselected-container ") + (disabled === true ? "disabled" : "cursor-pointer")}
                onClick={() => !disabled && cta && cta()}
            >
                <div className="horizontal-tab-content">
                    {iconLeft && icon && (
                        <div className="horizontal-tab-icon-container">
                            {icon}
                        </div>
                    )}
                    <span className={selected === true ? "body-bold colour-primary" : "body-regular colour-secondary"}>
                        {label}
                    </span>
                    {!iconLeft && icon && (
                        <div className="horizontal-tab-icon-container">
                            {icon}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
};

export default HorizontalTab;

